<app-search-layout *ngIf="authChecked" [contentOnCard]="false">
  <app-search-navbar
    searchNavbar
    [searchFieldList]="searchFieldList"
    [searchAction]="searchAction"
    [updateSearchValueAction]="updateSearchValueAction"
    [pageSize]="pageSize"
  ></app-search-navbar>
  <router-outlet searchContent></router-outlet>
</app-search-layout>
